import type { Building } from "building-types/building/buildingTypes";
import type { BuildingParameterValues } from "building-types/systemParameterTypes";
import { buildingStatsFromBuilding } from "./buildingStatsFromBuilding";
import { getBuildingFloorAreaTakeoffAreas } from "./getBuildingFloorAreaTakeoffAreas";
import { formatInchesFraction } from "./measurementUtils";

type SystemParameterBuildingDependencies = Pick<
  Building,
  "levels" | "buildingBounds" | "rooms" | "walls" | "optionChoices" | "doc" | "totalFloorArea" | "floorAreaTakeoffs"
>;

export function getBuildingParameterValues(
  buildingDependencies: SystemParameterBuildingDependencies,
): BuildingParameterValues {
  const stats = buildingStatsFromBuilding(buildingDependencies);
  const areas = getBuildingFloorAreaTakeoffAreas(buildingDependencies);
  return {
    buildingBedroomCount: stats.bedroomCount,
    buildingBathCount: stats.bathroomCount,
    buildingConditionedArea: stats.conditionedFloorArea,
    buildingUnconditionedArea: areas.unconditionedArea,
    buildingGarageArea: areas.garageArea,
    buildingFrontPorchPorticoArea: areas.frontPorchArea,
    buildingRearPorchArea: areas.rearPorchArea,
    buildingCoveredPatioArea: areas.coveredPatioArea,
    buildingUncoveredPatioArea: areas.uncoveredPatioArea,
    buildingGarageCount: stats.garageCount,
    buildingStoryCount: Object.keys(buildingDependencies.levels).length,
    buildingWidth: formatInchesFraction(buildingDependencies.buildingBounds.width),
    buildingDepth: formatInchesFraction(buildingDependencies.buildingBounds.depth),
    buildingHeight: formatInchesFraction(buildingDependencies.buildingBounds.height),
  };
}
